export class ENVIRONMENT_VARIABLE {
  static get CHANNEL_ENTRY_POINT() {
    const key = __environmentVariableKeyPrefix + "CHANNEL_ENTRY_POINT";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  static get COGNITO_IDENTITY_POOL_ID() {
    const key = __environmentVariableKeyPrefix + "COGNITO_IDENTITY_POOL_ID";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  static get COGNITO_USER_POOL_CLIENT_ID() {
    const key = __environmentVariableKeyPrefix + "COGNITO_USER_POOL_CLIENT_ID";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  static get COGNITO_USER_POOL_ID() {
    const key = __environmentVariableKeyPrefix + "COGNITO_USER_POOL_ID";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  static get FUNCTION_ENTRY_POINT() {
    const key = __environmentVariableKeyPrefix + "FUNCTION_ENTRY_POINT";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  /**
   * @deprecated `FUNCTION_ENTRY_POINT`を使用する。
   */
  static get LAMBDA_HTTP_ENTRY_POINT() {
    const key = __environmentVariableKeyPrefix + "FUNCTION_ENTRY_POINT";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }

  /**
   * @deprecated `CHANNEL_ENTRY_POINT`を使用する。
   */
  static get LAMBDA_WS_ENTRY_POINT() {
    const key = __environmentVariableKeyPrefix + "CHANNEL_ENTRY_POINT";
    const value = import.meta.env[key];
    if (typeof value === "string") {
      return value;
    } else {
      throw new Error(`Environment variable '${key}' is not set.`);
    }
  }
}
